import React from "react"
import ReactDOM from "react-dom"
// import App from './App';

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css"
// // Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min"

import { store } from "redux-store/store"
import { Provider } from "react-redux"
import "./index.css"
import App from "./App"

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
)
